import { css, withStyles } from '@recruit-robin/robin-theme/web-styles';

export const useStyles = withStyles({
  dialog: () => css`
    width: 100vw;
    height: 100vh;
    z-index: 3;
  `,
  content: () => css`
    max-height: 100vh;
    width: 600px;

    display: flex;
    flex-direction: column;

    padding-bottom: 0;
  `,
  title: () => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `,
  body: () => css`
    display: flex;
    flex-direction: column;
    gap: 24px;
    overflow-y: auto;
    padding-bottom: 20px;

    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    ::-webkit-scrollbar {
      display: none; /* Safari and Chrome */
    }
  `,
  questionsList: () => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin-bottom: 8px;
  `,
  questionItem: () => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 8px;
  `,
  buttons: css`
    width: 100%;
    align-items: flex-end;
    justify-content: flex-end;
    display: flex;
    gap: 8px;
  `,
  divider: ({ theme }) => css`
    display: flex;
    width: 100%;
    border-top: 1px solid ${theme.colors.neutral.variant[30]};
  `,
});
